import { useMediaQuery } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPrinciples } from "reduxStore/actions/principleActions";

export const usePrinciples = () => {
  const dispatch = useDispatch();
  const isLargeScreen = useMediaQuery("(min-width:1000px)");
  const principles = useSelector((state) => state.principles);

  const user = useSelector((state) => state.user);

  const roles = user?.roles || [];

  const isSystemAdmin = roles.some((role) => role.name === "System Admin");
  const isOrgAdmin = roles.some((role) => role.name === "Trust Admin");

  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false); // Track if we are in edit mode
  const [currentPrinciple, setCurrentPrinciple] = useState(null); // Store the user being edited

  const handleOpen = useCallback(() => {
    setEditMode(false);
    setCurrentPrinciple(null);
    setOpen(true);
  }, []);

  const handleEditOpen = useCallback((principle) => {
    setEditMode(true);
    setCurrentPrinciple(principle);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  useEffect(() => {
    dispatch(fetchPrinciples());
  }, [dispatch]);

  return {
    isLargeScreen,
    principles,
    isSystemAdmin,
    isOrgAdmin,
    open,
    editMode,
    currentPrinciple,
    handleOpen,
    handleEditOpen,
    handleClose,
    setOpen,
  };
};
